import { createFeatureSelector, createSelector } from '@ngrx/store';

import { BookingState } from '@modules/booking/store';

const selectBookingState = createFeatureSelector<BookingState>('booking');

const selectEmployeesState = createSelector(selectBookingState, (s) => s.proceedButton);

export const selectDisplayProceedButton = createSelector(selectEmployeesState, (s) => s.display);
